import type { QuestionnaireStore } from "../Store";
import type { QuestionnaireSummary } from "@/Modules/Models/Domain/Questionnaire";
import { QuestionnaireType } from "@/Modules/Models/Domain/Questionnaire";

import QuestionnaireApiConnector from "@/Services/TherapyApi/Questionnaires";

import QuestionnaireSummaryTransformer from "@/Modules/Transformers/Questionaire/QuestionnaireSummary";

class CreateDeleteAndUnsubscribeQuestionnaire {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionnaireApiConnector = new QuestionnaireApiConnector(),
    private readonly questionnaireSummaryTransformer = QuestionnaireSummaryTransformer
  ) {}

  public async handle(userId: string, questionnaireId: string): Promise<QuestionnaireSummary> {
    const quiz = this.findQuestionnaire(this.questionnaireStore, questionnaireId);

    if (quiz) {
      return quiz;
    }

    const questionnaireApiResponse = await this.questionnaireApiConnector.createQuestionnaire(
      userId,
      userId,
      userId,
      questionnaireId
    );
    const questionnaire = await this.questionnaireSummaryTransformer.toDomain(questionnaireApiResponse);

    if (questionnaire.type === QuestionnaireType.CUSTOMER_ABOUT_DELETE) {
      this.questionnaireStore.deleteAndUnsubscribeQuestionnaires.push(questionnaire);
    }

    return questionnaire;
  }

  private findQuestionnaire(questionnaireStore: QuestionnaireStore, questionnaireId: string) {
    const questionnaires = questionnaireStore.deleteAndUnsubscribeQuestionnaires.filter((quiz) => {
      return quiz.questionnaireId === questionnaireId && !quiz.isCompleted;
    });

    if (questionnaires.length) {
      return questionnaires[0];
    }
  }
}

export default CreateDeleteAndUnsubscribeQuestionnaire;
